import type { TimeZoneId } from '../types';

// USER_TIME_ZONE is undefined only in IE11
const USER_TIME_ZONE: TimeZoneId | null | undefined =
	Intl.DateTimeFormat().resolvedOptions().timeZone !== 'Etc/Unknown'
		? Intl.DateTimeFormat().resolvedOptions().timeZone
		: null;

export const getUserTimezone = (): TimeZoneId | null | undefined => USER_TIME_ZONE;
